import { DealXgSocketActions } from '../socket/dealXgSocketActionTypes';
import type { DealRefreshAction, DealRefreshModalState } from './types';
import { initialState } from './initialState';

export const dealRefreshReducer = (
    state: DealRefreshModalState = initialState,
    action: DealRefreshAction
): DealRefreshModalState => {
    switch (action.type) {
        case DealXgSocketActions.SHOW_DEAL_REFRESH_MODAL:
            return { ...state, isVisible: true };
        case DealXgSocketActions.REFRESH_DEAL_REQUESTED:
            return { ...state, isVisible: false };
        default:
            return state;
    }
};
